module.exports = __webpack_public_path__ + "static/media/mountains-small-taggis.4a853639.jpg";